module.exports =
  fontPreview: '/internal/common/fontPreview'
  resizeImage: '/internal/common/resizeImage'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/common.coffee